// @ts-strict-ignore

import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

export interface EngagementPresetEmailTemplatesParams extends BaseTableParams {
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

const NINETY_DAYS_SECONDS = 90 * 24 * 60 * 60;

export function isPresetTemplateNew(createdAtTimestamp: number | undefined | null): boolean {
  if (!createdAtTimestamp) {
    return false;
  }
  const nowSeconds = Math.floor(Date.now() / 1000);
  return nowSeconds - createdAtTimestamp < NINETY_DAYS_SECONDS;
}

export interface EngagementPresetEmailTemplatesResultItem extends BaseTableResultItem {
  id: string;
  name: string;
  template: string;
  thumbnail_image_url;
  is_dnd_template: boolean;
  created_at_timestamp?: number | null;
}

export type EngagementPresetEmailTemplatesResult = TableResult<EngagementPresetEmailTemplatesResultItem>;
